import Box from '@mui/material/Box';
// import { headerHeight, headerHeightMb } from '~/styles';
import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { BrowserRouter as Router } from 'react-router-dom';
import { DGlobe } from '~/assets';
import { LGlobe } from '~/assets';
import { AGlobe } from '~/assets';
import { flogo } from '~/assets';
import { slogo } from '~/assets';
import { tlogo } from '~/assets';
import { bullet } from '~/assets';
// import Planet1 from "../../assets/svgs/"
import { makeStyles } from '@material-ui/core/styles';

import { DLACard } from '../../components';
import { height } from '@mui/system';
import { Divider } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  globes: {
    height: 100,
    [theme.breakpoints.up('sm')]: { height: 190 },
  },
}));

export const DLAbanner = () => {
  const classes = useStyles();
  const data = [
    {
      globe: <img src={DGlobe} height={200} className={classes.globes} alt="globe"></img>,
      para: (

        <Box display='flex' flexDirection='column'>

          <Box mb={2}>
            <Typography fontSize={{xs:'16px', lg:'20px'}} lineHeight='110%' variant="body1">Decentralised</Typography>
          </Box>
          <Box mt={1} alignItems='top' display='flex' flexDirection='row'>
            <img style={{height:'fit-content', marginTop:'3px'}} src={bullet} alt="globe"></img>
            <Typography fontSize={{xs:'13px', lg: '15px'}} lineHeight={{xs:'23px', lg:'26px'}} paddingLeft={2} variant='body2'>Organising a group of people focused on the same goal</Typography>
          </Box>
          <Box mt={1} alignItems='top' display='flex' flexDirection='row'>
            <img style={{height:'fit-content', marginTop:'3px'}} src={bullet} alt="globe"></img>
            <Typography fontSize={{xs:'13px', lg: '15px'}} lineHeight={{xs:'23px', lg:'26px'}} paddingLeft={2} variant='body2'>Community values upheld</Typography>
          </Box>
          <Box mt={1} alignItems='top' display='flex' flexDirection='row'>
            <img style={{height:'fit-content', marginTop:'3px'}} src={bullet} alt="globe"></img>
            <Typography fontSize={{xs:'13px', lg: '15px'}} lineHeight={{xs:'23px', lg:'26px'}} paddingLeft={2} variant='body2'>Aligned economic and social incentives around $SKILLS</Typography>
          </Box>

        </Box>
        // <Box>
        //   <Typography variant="body1"> Decentralised </Typography>,
        //   <Typography
        //     display="flex"
        //     alignItems="center"
        //     sx={{
        //       color: '#fff',
        //       marginBottom: 1,
        //     }}
        //     variant='body2'
        //   >
        //     <img style={{ marginRight: 15, verticalAlign:'top' }} src={bullet} alt="globe"></img>
        //     Organising a group of people focused on the same goal
        //   </Typography>


        //   <Typography
        //     display="flex"
        //     alignItems="center"
        //     sx={{
        //       color: '#fff',
        //       marginBottom: 1,
        //     }}
        //     variant="body2"
        //   >
        //     <img style={{ marginRight: 15 }} src={bullet} alt="globe"></img>
        //     Community values upheld 
        //   </Typography>
        //   <Typography
        //     display="flex"
        //     alignItems="center"
        //     sx={{ color: '#fff', marginBottom: 1 }}
        //     variant="body2"
        //   >
        //     <img style={{ marginRight: 15 }} src={bullet} alt="globe"></img>
        //     Aligned economic and social incentives around $SKILLS
        //   </Typography>
        // </Box>
      ),
      num: (
        <Box
          height={100}
          // width={200}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <img src={flogo} height={88} alt="logo" />
        </Box>
      ),
    },
    {
      globe: (
        <img src={LGlobe} alt="logo" height={200} className={classes.globes} />
      ),
      para: (
        <Box display='flex' flexDirection='column'>

          <Box mb={2}>
            <Typography fontSize={{xs:'16px', lg:'20px'}} lineHeight='110%' variant="body1">Learning</Typography>
          </Box>
          <Box mt={1} alignItems='top' display='flex' flexDirection='row'>
            <img style={{height:'fit-content', marginTop:'3px'}} src={bullet} alt="globe"></img>
            <Typography fontSize={{xs:'13px', lg: '15px'}} lineHeight={{xs:'23px', lg:'26px'}} paddingLeft={2} variant='body2'>Specific use-case for education</Typography>
          </Box>
          <Box mt={1} alignItems='top' display='flex' flexDirection='row'>
            <img style={{height:'fit-content', marginTop:'3px'}} src={bullet} alt="globe"></img>
            <Typography fontSize={{xs:'13px', lg: '15px'}} lineHeight={{xs:'23px', lg:'26px'}} paddingLeft={2} variant='body2'>Transparent business model with Learn to Earn characteristics</Typography>
          </Box>
          <Box mt={1} alignItems='top' display='flex' flexDirection='row'>
            <img style={{height:'fit-content', marginTop:'3px'}} src={bullet} alt="globe"></img>
            <Typography fontSize={{xs:'13px', lg: '15px'}} lineHeight={{xs:'23px', lg:'26px'}} paddingLeft={2} variant='body2'>Features developed to enhance the learning process</Typography>
          </Box>
          <Box mt={1} alignItems='top' display='flex' flexDirection='row'>
            <img style={{height:'fit-content', marginTop:'3px'}} src={bullet} alt="globe"></img>
            <Typography fontSize={{xs:'13px', lg: '15px'}} lineHeight={{xs:'23px', lg:'26px'}} paddingLeft={2} variant='body2'>Versatile platform structure</Typography>
          </Box>

        </Box>


        // <Box
        //   display="flex"
        //   flexDirection="column"
        //   alignItems="flex-start"
        //   justifyContent="flex-start"
        // >
        //   <Typography variant="body1"> Learning </Typography>,
        //   <Typography
        //     display="flex"
        //     alignItems="center"
        //     sx={{ color: '#fff', marginBottom: 1 }}
        //     variant="body2"
        //   >
        //     <img style={{ marginRight: 15 }} src={bullet} alt="globe"></img>
        //     Specific use-case for education
        //   </Typography>
        //   <Typography
        //     display="flex"
        //     alignItems="center"
        //     sx={{ color: '#fff', marginBottom: 1 }}
        //     variant="body2"
        //   >
        //     <img style={{ marginRight: 15 }} src={bullet} alt="globe"></img>
        //     Transparent business model with Learn to Earn characteristics
        //   </Typography>
        //   <Typography
        //     display="flex"
        //     alignItems="center"
        //     sx={{ color: '#fff', marginBottom: 1 }}
        //     variant="body2"
        //   >
        //     <img style={{ marginRight: 15 }} src={bullet} alt="globe"></img>
        //     Features developed to enhance the learning process
        //   </Typography>
        //   <Typography
        //     display="flex"
        //     alignItems="center"
        //     sx={{ color: '#fff', marginBottom: 1 }}
        //     variant="body2"
        //   >
        //     <img style={{ marginRight: 15 }} src={bullet} alt="globe"></img>
        //     Versatile platform structure{' '}
        //   </Typography>
        // </Box>
      ),
      num: (
        <Box
          height={100}
          // width={200}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <img height={88} src={slogo} alt="globe"></img>
        </Box>
      ),
    },
    {
      globe: (
        <img
          src={AGlobe}
          height={200}
          alt="globe"
          className={classes.globes}
        ></img>
      ),
      para: (

        <Box display='flex' flexDirection='column'>

          <Box mb={2}>
            <Typography fontSize={{xs:'16px', lg:'20px'}} lineHeight='110%' variant="body1">Academy</Typography>
          </Box>
          <Box mt={1} alignItems='top' display='flex' flexDirection='row'>
            <img style={{height:'fit-content', marginTop:'3px'}} src={bullet} alt="globe"></img>
            <Typography fontSize={{xs:'13px', lg: '15px'}} lineHeight={{xs:'23px', lg:'26px'}} paddingLeft={2} variant='body2'>Incorporation of roles and responsibilities</Typography>
          </Box>
          <Box mt={1} alignItems='top' display='flex' flexDirection='row'>
            <img style={{height:'fit-content', marginTop:'3px'}} src={bullet} alt="globe"></img>
            <Typography fontSize={{xs:'13px', lg: '15px'}} lineHeight={{xs:'23px', lg:'26px'}} paddingLeft={2} variant='body2'>Creating, curating and cultivating knowledge</Typography>
          </Box>
          <Box mt={1} alignItems='top' display='flex' flexDirection='row'>
            <img style={{height:'fit-content', marginTop:'3px'}} src={bullet} alt="globe"></img>
            <Typography fontSize={{xs:'13px', lg: '15px'}} lineHeight={{xs:'23px', lg:'26px'}} paddingLeft={2} variant='body2'>Community building</Typography>
          </Box>
          <Box mt={1} alignItems='top' display='flex' flexDirection='row'>
            <img style={{height:'fit-content', marginTop:'3px'}} src={bullet} alt="globe"></img>
            <Typography fontSize={{xs:'13px', lg: '15px'}} lineHeight={{xs:'23px', lg:'26px'}} paddingLeft={2} variant='body2'>Long term approach to learning</Typography>
          </Box>

        </Box>


        // <Box>
        //   <Typography variant="body1"> Academy </Typography>,
        //   <Typography
        //     display="flex"
        //     alignItems="center"
        //     sx={{ color: '#fff', marginBottom: 1 }}
        //     variant="body2"
        //   >
        //     <img style={{ marginRight: 15 }} src={bullet} alt="globe"></img>
        //     Incorporation of roles and responsibilities
        //   </Typography>
        //   <Typography
        //     display="flex"
        //     alignItems="center"
        //     sx={{ color: '#fff', marginBottom: 1 }}
        //     variant="body2"
        //   >
        //     <img style={{ marginRight: 15 }} src={bullet} alt="globe"></img>
        //     Creating, curating and cultivating knowledge
        //   </Typography>
        //   <Typography
        //     display="flex"
        //     alignItems="center"
        //     sx={{ color: '#fff', marginBottom: 1 }}
        //     variant="body2"
        //   >
        //     <img style={{ marginRight: 15 }} src={bullet} alt="globe"></img>
        //     Community building
        //   </Typography>
        //   <Typography
        //     display="flex"
        //     alignItems="center"
        //     sx={{ color: '#fff', marginBottom: 1 }}
        //     variant="body2"
        //   >
        //     <img style={{ marginRight: 15 }} src={bullet} alt="globe"></img>
        //     Long term approach to learning
        //   </Typography>
        // </Box>
      ),
      num: (
        <Box
          height={100}
          // width={200}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <img height={88} src={tlogo} alt="logo" />
        </Box>
      ),
    },
  ];
  return (
    <Box  maxWidth="1440px" width='100%'>
      <Box
        bgcolor={'#141420'}
        sx={{ borderRadius: '8px' }}
        marginX={{ xs: 2, lg: 10, xl:0 }}
        padding={{ xs: 2, lg: 5 }}
        justifyContent="center"
        alignItems="center"
      >
        <Box
          justifyContent="center"
          textAlign="center"
          paddingY={{lg: 10, xs: 3}}
          marginX={1}
        >
          <Typography variant="h5" 
          align="center"
          style={{
            backgroundColor:"#F69501",
            backgroundImage: 'linear-gradient(268.99deg, #F69501 0.03%, #F1756E 100.53%)',
            WebkitTextFillColor:'transparent',
            backgroundClip:'text',
            WebkitBackgroundClip:'text'
          }}
          fontSize={{xs:'12px', md:'16px'}}
          lineHeight={{xs:'18px', md:'26px'}}
          letterSpacing='0.2rem'
          >
            WHAT IS A DECENTRALISED LEARNING ACADEMY ?
          </Typography>
          <Typography mt={2} fontSize={{lg: '40px', xs: '24px'}} variant="h6">The best way of approaching a DLA</Typography>
        </Box>
        <Box style={{ paddingBottom: 40 }} marginX={{ xs: 0, lg: 10 }}>
          {data.map((item, index) => {
            return (
              <>
                <DLACard
                  globe={item.globe}
                  para={item.para}
                  num={item.num}
                  reverse={index == 1 ? true : false}
                  end={index === data.length - 1 ? true : false}
                  first={index==0? true: false}
                />
              </>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};
